<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'70%'">
    <v-layout v-if="itemDetail">
      <v-flex>
        <v-card>
          <v-card-title>促銷頁面管理</v-card-title>
          <v-card-text>
            <v-layout v-for="col in getDialogKeys" :key="col.value">
              <v-flex>
                <v-textarea v-if="col.value === 'content'"
                              class="mb-2 mt-2"
                              v-model="itemDetail[col.value]"
                            :label="col.text"
                            :color="Theme.GREEN"
                />
                <v-menu v-else-if="col.value === 'startDate'"
                        ref="saleStartDateMenu"
                        v-model="saleStartDateMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        :return-value="itemDetail[col.value]"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="itemDetail[col.value]"
                                  :label="col.text"
                                  :color="Theme.GREEN" readonly v-on="on"></v-text-field>
                    <!--                  <input :placeholder="col.text" class="textInput"-->
                    <!--                         :label="col.text"-->
                    <!--                         v-model="itemDetail[col.value]" readonly v-on="on">-->
                  </template>
                  <v-date-picker
                      v-model="itemDetail[col.value]" no-title
                      @input="changeDate(itemDetail[col.value])"
                      @change="changeDate(itemDetail[col.value])"
                      :color="Theme.GREEN" scrollable>
                  </v-date-picker>
                </v-menu>
                <v-menu v-else-if="col.value === 'endDate'"
                        ref="saleEndDateMenu"
                        v-model="saleEndDateMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        :return-value="itemDetail[col.value]"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="itemDetail[col.value]"
                                  :label="col.text"
                                  :color="Theme.GREEN" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="itemDetail[col.value]" no-title
                      @input="changeDate(itemDetail[col.value])"
                      @change="changeDate(itemDetail[col.value])"
                      :color="Theme.GREEN" scrollable>
                  </v-date-picker>
                </v-menu>
                <v-text-field v-else v-model="itemDetail[col.value]"
                              :label="col.text"
                              :disabled="col.disable"
                              :color="Theme.GREEN"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="saveData">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-dialog>

</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

export default {
  name: "sale",
  mixins: [common],
  props: {
    visible: Boolean,
    showCancel: Boolean,
    itemDetail: Object,
    isEdit: Boolean,
  },
  data(){
    return {
      saveLoading: false,
      saleStartDateMenu: false,
      saleEndDateMenu: false,
    }
  },
  watch:{
    // visible(value){
      // if (value === true){
      //   this.loadData();
      // }
      // console.log(`key == ${this.key}`)
    // }
  },
  created() {

  },
  mounted() {
    // console.log('this is current quill instance object', this.editor)
  },
  computed: {
    getDialogKeys() {
      return [
        { value:'coupon', text:'優惠代碼', disable: this.isEdit },
        { value:'startDate', text:'開始時間' , disable: false },
        { value:'endDate', text:'結束時間', disable: false },
        { value:'content', text:'折扣說明', sortable: false, disable: false },
        { value:'price', text:'折扣金額(元)', sortable: false , disable: false},
        { value:'conditionPrice', text:'滿額條件(>= ?元)', sortable: false, disable: false },
      ];
    },
  },
  methods: {
    ...mapActions(['getSaleInfo', 'saveSaleInfo']),
    changeDate(date){
      console.log(`changeDate == ${JSON.stringify(date)}`);
    },
    async loadData(){
      console.log(`loadData ${JSON.stringify(this.itemDetail)}`);

      this.loading = true;
      const res = await this.getSaleInfo({ pageId: this.itemDetail.pageId });

      if (res.data.code === 0){
        this.itemDetail = res.data.body;

        console.log(`getSaleInfo ${JSON.stringify(res.data.body)}`);
      }
      this.loading = false;
    },
    async saveData(){

      if (!this.itemDetail.startDate || this.itemDetail.startDate === ''||
          !this.itemDetail.endDate || this.itemDetail.endDate === ''){
        this.showMessageDialog('錯誤', '請輸入優惠代碼有效時間');
        return;
      }

      if (this.itemDetail.price === ''){
        this.showMessageDialog('錯誤', '請輸入折扣金額');
        return;
      }

      if (this.itemDetail.price === ''){
        this.showMessageDialog('錯誤', '請輸入滿額條件金額，如不需要滿額則輸入0');
        return;
      }
      this.saveLoading = true;
      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveSaleInfo({ info: this.itemDetail });
      const result = res.data;
      this.saveLoading = false;
      if (result.statusCode === 0) {
        this.showMessageDialog('成功', '儲存成功');
        this.$emit('successEvent');
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
  }
}
</script>

<style scoped>

</style>
